// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OldGuidelines_wrapper__TSESb","innerWrapper":"OldGuidelines_innerWrapper__2uF25","mainTitle":"OldGuidelines_mainTitle__1txY0"};